import * as React from 'react';
import * as styles from './Page.css';

export const Page: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
